export default __webpack_public_path__ + "assets/images/c491a9dcb4e15ced1a34e55201f1c5a7.png";